// Sawyer 09 pet-inactivity (D1)
/**
 * Quick Book's "book anyway" field for the #718 meet-and-greet hold.
 *
 * Before this, Quick Book showed the server's 409 sentence ("Re-submit with
 * assessmentOverrideReason …") with no way to send it, so the desk with an
 * owner on the phone hit a dead end (Design Philosophy #2: the next action
 * is obvious). Same field name, bounds and wording family as the
 * EditReservationDialog override, so the desk learns it once.
 *
 * The parent LATCHES it on (the EditReservationDialog rule): once the server
 * has asked for a reason the field stays until the panel closes. The value is
 * sent only once it can be accepted (3–300 characters).
 *
 * Principles: #2 next action obvious, #5 never lie (the label says it is
 * logged against the staffer), #7 built for hands (full-width 44px input).
 *
 * Counter Test: Kylie reads "Biscuit has not visited since Dec 9, 2098 …",
 * types "Regular, owner on the phone" and presses Book again; it books and
 * the audit log names her.
 */
export const OVERRIDE_MIN = 3;
export const OVERRIDE_MAX = 300;

/** The reason to send, or undefined until it is long enough to be accepted. */
export function acceptedOverride(raw: string): string | undefined {
  const t = raw.trim();
  return t.length >= OVERRIDE_MIN ? t.slice(0, OVERRIDE_MAX) : undefined;
}

export function AssessmentOverrideField({
  value,
  onChange,
  disabled,
}: {
  value: string;
  onChange(next: string): void;
  disabled: boolean;
}): JSX.Element {
  const length = value.trim().length;
  const tooShort = length > 0 && length < OVERRIDE_MIN;
  return (
    <label className="ferro-field" data-testid="quickbook-assessment-override-field">
      <span className="ferro-field__label">Reason to book anyway (logged against you)</span>
      <input
        type="text"
        className="ferro-field__input"
        value={value}
        minLength={OVERRIDE_MIN}
        maxLength={OVERRIDE_MAX}
        disabled={disabled}
        placeholder="Regular, owner on the phone"
        onChange={(e) => onChange(e.target.value)}
        aria-describedby="quickbook-assessment-override-hint"
        data-testid="quickbook-assessment-override"
      />
      <span className="ferro-field__hint" id="quickbook-assessment-override-hint">
        {tooShort ? `At least ${OVERRIDE_MIN} characters.` : `${value.length}/${OVERRIDE_MAX}`}
      </span>
    </label>
  );
}
